import { render, staticRenderFns } from "./VPreloader.vue?vue&type=template&id=153f2b42&scoped=true&"
import script from "./VPreloader.vue?vue&type=script&lang=js&"
export * from "./VPreloader.vue?vue&type=script&lang=js&"
import style0 from "./VPreloader.vue?vue&type=style&index=0&id=153f2b42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153f2b42",
  null
  
)

export default component.exports